import startCase from 'lodash/startCase';
import { arrayOf, func, shape, string } from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import { optionShape } from '../../prop-types';
import GroupSelect from '../GroupSelect';
import MultiSelect from '../MultiSelect';

export default function LineFilters({ onChange, filters }) {
  return (
    <div>
      <h6>Filter</h6>
      <Row>
        {filters.map(({ name, all, selected }) => {
          const Component = name === 'categories' ? GroupSelect : MultiSelect;
          return (
            <Col sm={3} key={name}>
              <Component
                placeholder={startCase(name)}
                value={selected}
                name={name}
                options={all}
                onChange={onChange}
                isClearable
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

const filterShape = shape({
  name: string.isRequired,
  all: arrayOf(optionShape.isRequired).isRequired,
  selected: arrayOf(string.isRequired).isRequired,
});

LineFilters.propTypes = {
  filters: arrayOf(filterShape.isRequired).isRequired,
  onChange: func.isRequired,
};
